var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import _ from 'lodash';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { usePreferences } from '@/ducks/PreferencesContext';
import { Toggle } from '@/ui-toolkit/indexExportV2';
/**
 * Hook to create a toggle that persists its state in the global preferences.
 *
 * @param id The identifier to use for the preference within the global preferences object.
 * @param label The label to render next to the toggle.
 * @param config Optional configuration for the toggle.
 */
export var useStickyToggle = function (id, label, config) {
    if (config === void 0) { config = {}; }
    var preferencesContext = usePreferences();
    var preferences, setPreference;
    if (config.scope === 'global') {
        preferences = preferencesContext.globalPreferences;
        setPreference = preferencesContext.setGlobalPreference;
    }
    else {
        preferences = preferencesContext.preferences;
        setPreference = preferencesContext.setPreference;
    }
    var isChecked = useMemo(function () { var _a, _b; return (_b = (_a = _.get(preferences, id)) !== null && _a !== void 0 ? _a : config.defaultChecked) !== null && _b !== void 0 ? _b : false; }, [preferences, id, config.defaultChecked]);
    var setIsChecked = function (value) {
        setPreference(id, value);
    };
    var handleOnChange = function (e) {
        setIsChecked(e.target.checked);
    };
    var Component = function () {
        return (React.createElement(ToggleWrapper, null,
            React.createElement(Toggle, { checked: isChecked, direction: config.direction, label: label, name: id, size: config.size, onChange: handleOnChange })));
    };
    return {
        /**
         * The current state of the toggle.
         */
        isChecked: isChecked,
        /**
         * Function to set the state of the toggle. This will also persist the state in the global preferences.
         */
        setIsChecked: setIsChecked,
        /**
         * The toggle component to render.
         */
        Component: Component,
    };
};
var ToggleWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    label {\n        margin-bottom: 0;\n    }\n"], ["\n    label {\n        margin-bottom: 0;\n    }\n"])));
var templateObject_1;
